/**
* DevExpress Dashboard (_filter-expression-editor.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { DisplayExpressionConverter } from '@devexpress/analytics-core/analytics-internal';
import { FilterEditor } from '@devexpress/analytics-core/analytics-widgets';
import * as ko from 'knockout';
export class FilterExpressionEditorViewModel {
    constructor(params) {
        this.params = params;
        this.editorTemplate = 'dx-filtereditor-popup';
        this.criteriaString = ko.observable();
        this.editor = new FilterEditor(params.options, params.fieldListProvider, false, params.displayNameProvider);
        ko.computed(() => {
            var displayExpressionConverter = new DisplayExpressionConverter(params.displayNameProvider);
            displayExpressionConverter.toDisplayExpression(params.options().path(), params.options().value()).done((result) => {
                this.criteriaString(result);
            }).fail(() => {
                this.criteriaString(params.options().value());
            });
        });
    }
    edit() {
        this.editor.popupVisible(true);
    }
    remove() {
        this.params.options().value(null);
    }
}
